import type { ComponentLineProps } from "../../FirstPaymentPreview/types";
import { RawLines } from "../RawLines";

export const TaxLine = ({ preview, options }: ComponentLineProps) => {
  if (!preview.future_payments || preview.future_payments.tax <= 0) {
    return null;
  }

  return <RawLines.TaxLine preview={preview} options={options} />;
};
